import { User } from 'sharebase/domain';

export function UsersFilter() {
	return function getUsers(users:User[], matchText:string) {
		if (!matchText) { 
			return users; 
		}

		matchText = matchText.toLowerCase();
		return users.filter(user => {
			let userName = user.userName.toLowerCase();
			let email = user.emailAddress.toLowerCase();
			return userName.indexOf(matchText) > -1 || email.indexOf(matchText) > -1;
		});
	};
}


// WEBPACK FOOTER //
// ./src/sharebase/filters/users.ts